import { listCollection } from "../lib/content.server.js";
import { buildMeta } from "../lib/seo.js";
import { track } from "../lib/analytics.js";
import PageHero from "../components/PageHero/PageHero.jsx";
import styles from "./whitepapers.module.css";

const PAGE = {
  title: "Whitepapers",
  description: "Downloadable whitepapers and RDV Systems' statement of qualifications.",
  path: "/resources/whitepapers",
};

export function meta() {
  return buildMeta(PAGE);
}

export async function loader() {
  return { items: listCollection("whitepapers") };
}

export default function Whitepapers({ loaderData }) {
  return (
    <>
      <PageHero
        eyebrow="Whitepapers"
        title="Whitepapers and qualifications"
        lead={PAGE.description}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Resources", path: "/resources" },
          { name: "Whitepapers", path: PAGE.path },
        ]}
      />
      <section className="section">
        <div className={`container ${styles.list}`}>
          {loaderData.items.map((w) => (
            <article key={w.slug}>
              <h2>{w.title}</h2>
              <p>{w.description}</p>
              <a
                className="btn btn-primary"
                href={w.pdf}
                download
                onClick={() => track("pdf_download", { file: w.pdf })}
              >
                Download PDF{w.pages ? ` (${w.pages} pages)` : ""}
              </a>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
